export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14 bg-gradient-to-r from-primary-500/10 via-accent-500/10 to-primary-500/5 rounded-2xl p-8 md:p-12">
          <div className="flex-shrink-0">
            <div className="w-28 h-28 md:w-36 md:h-36 rounded-2xl bg-background-50 flex items-center justify-center border border-background-300/40">
              <i className="ri-smartphone-line text-5xl md:text-6xl text-primary-500 w-14 h-14 md:w-16 md:h-16 flex items-center justify-center"></i>
            </div>
          </div>
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">桔子影视 App 客户端</h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-2xl">
              随时随地追剧不设限。桔子影视移动客户端支持 iOS 与 Android 双平台，提供与网页端同步的高清画质与流畅体验。
              支持离线缓存、片单收藏、追剧提醒和个性化推荐，让您的追剧体验更加便捷高效。打开手机，精彩即刻呈现。
            </p>
            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
              <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg bg-background-50 text-foreground-700 text-sm border border-background-300/60 whitespace-nowrap cursor-pointer">
                <i className="ri-apple-line text-base w-4 h-4 flex items-center justify-center"></i>
                iOS 版
              </span>
              <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg bg-background-50 text-foreground-700 text-sm border border-background-300/60 whitespace-nowrap cursor-pointer">
                <i className="ri-android-line text-base w-4 h-4 flex items-center justify-center"></i>
                Android 版
              </span>
              <span className="inline-flex items-center gap-1.5 px-4 py-2 rounded-lg bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap cursor-pointer">
                扫码下载
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}